import {
  Box,
  BoxProps,
  Flex,
  FlexProps,
  HStack,
  StackProps,
  TableContainer,
  TableContainerProps,
  WhiteCard,
} from '@elkaso-app/web-design';
import { BaseTableContainerSkeleton } from 'components/base-table/components';

/**
 * Base Table Container Header
 */
const HeaderLeft = (props: StackProps) => {
  return <HStack spacing='sm' {...props} />;
};

Header.Left = HeaderLeft;

const HeaderRight = (props: StackProps) => {
  return <HStack spacing='sm' {...props} />;
};

Header.Right = HeaderRight;

function Header(props: FlexProps) {
  // wrap + rowGap only engage when the two sides can't share a line (phones);
  // on wider screens the layout is unchanged
  return (
    <Flex p={{ base: 'sm', md: 'md' }} align={'center'} justify={'space-between'} wrap='wrap' rowGap='sm' {...props} />
  );
}

BaseTableContainer.Header = Header;

/**
 * Base Table Container Table Wrapper
 */
function TableWrapper(props: TableContainerProps) {
  // the 400px floor overshoots short phone viewports and forces the page to scroll twice
  return (
    <TableContainer
      flexGrow={1}
      overflowY='auto'
      minH={{ base: '200px', md: '400px' }}
      position='relative'
      zIndex={0}
      {...props}
    />
  );
}

BaseTableContainer.TableWrapper = TableWrapper;

/**
 * Base Table Container Footer
 */
const FooterLeft = (props: BoxProps) => {
  return <Box {...props} />;
};

Footer.Left = FooterLeft;

const FooterRight = (props: BoxProps) => {
  return <Box {...props} />;
};

Footer.Right = FooterRight;

function Footer(props: FlexProps) {
  return (
    <Flex
      p={{ base: 'sm', md: 'md' }}
      align={'center'}
      justify={'space-between'}
      wrap='wrap'
      rowGap='sm'
      borderTop='1px solid'
      borderColor='gray.200'
      {...props}
    />
  );
}

BaseTableContainer.Footer = Footer;

/**
 * Base Table Container
 */
interface IBaseTableContainer extends BoxProps {
  isLoading?: boolean;
}

export function BaseTableContainer({ isLoading, ...rest }: IBaseTableContainer) {
  if (isLoading) return <BaseTableContainerSkeleton />;
  return <WhiteCard display='flex' flexDir='column' minH='100%' maxH='100%' {...rest} />;
}
